import { useCallback } from "react"
import { useAppSelector } from "../store/storeHooks"
import { selectSelectedLocale, selectSupportedLocales } from "./localizationSelectors"
import { useDispatch } from "react-redux"
import { setRequestedLocale } from "./localizationSlice"
import { Logger } from "../../lib/logging"

export function useLocaleSelect() {
    const supportedLocales = useAppSelector(selectSupportedLocales)
    const selectedLocale = useAppSelector(selectSelectedLocale)
    const dispatch = useDispatch()

    const selectLocale = useCallback(
        (locale: string) => dispatch(setRequestedLocale({ locale })),
        [dispatch, setRequestedLocale],
    )

    return {
        supportedLocales,
        selectedLocale,
        selectLocale,
    }
}

type UseLocalizedUrlOptions = Readonly<{
    defaultUrl: string
}>

export function useLocalizedUrl(localeUrls: Record<string, string>, { defaultUrl }: UseLocalizedUrlOptions) {
    const logger = new Logger("l18n")
    const selectedLocale = useAppSelector(selectSelectedLocale)

    const urlToUse = localeUrls[selectedLocale]

    logger.info(`Selecting URL for locale '${selectedLocale}': ${urlToUse} [fallback URL: ${defaultUrl}]`)
    return urlToUse ? urlToUse : defaultUrl
}
